import { slugify } from '@finn/ui-utils';

import { GenericVehicleDetails } from '../types';

export const getModelPagePath = (
  vehicle: Pick<GenericVehicleDetails, 'model' | 'brand'>
) => {
  return `${slugify(vehicle.brand.id)}/${slugify(vehicle.model)}`;
};
